import "react-medium-image-zoom/dist/styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { CyHeader } from "./CyHeader";
import { PropsWithChildren } from "react";
import { Button } from "reactstrap";
import { useChordsheetPersistenceStatus } from "../../chordsheet/ChordsheetPersistenceState";

interface Props {
  setIsMainMenuOpen: (
    value: ((prevState: boolean) => boolean) | boolean,
  ) => void;
}

export function HeaderButtonBurger({
  setIsMainMenuOpen,
}: PropsWithChildren<Props>) {
  const status = useChordsheetPersistenceStatus();
  const isRunning = status === "running";

  return (
    <Button
      color="primary"
      className="flex-grow-1"
      data-cy={CyHeader.HeaderButton}
      data-background-process-status={status}
      onClick={() => setIsMainMenuOpen((s) => !s)}
    >
      <FontAwesomeIcon icon={isRunning ? faSpinner : faBars} spin={isRunning} />
    </Button>
  );
}
